"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orgSettings = void 0;
exports.orgSettings = {
    title: "Working hours & reminders",
    subtitle: "Set when your organization works and when automated reminders go out.",
    loadError: "Couldn’t load organization settings. Check your connection and try again.",
    retry: "Retry",
    save: "Save",
    saved: "Settings saved",
    timezone: "Timezone",
    timezoneHelper: "All times below are in this timezone. Contact HHN support to change it.",
    workingHours: "Working hours",
    workingHoursHelper: "Automatic reminders due during these hours go out at their usual time.",
    start: "Start",
    end: "End",
    reminderTime: "Preferred reminder time",
    reminderTimeHelper: "Automatic reminders due outside working hours go out at this time instead.",
    errors: {
        required: "Enter a valid time.",
        startBeforeEnd: "Start must be before end.",
        outsideWorkingHours: "Must be within working hours ({{start}} – {{end}}).",
    },
};
